export default __webpack_public_path__ + "static/media/SolarSystem_18.894e29af.png";